import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/login/login.vue'
import Download from '@/components/contract/contract-download.vue'
import View from '@/components/contract/contract-pdf-view.vue'

Vue.use(Router)

export default new Router({
  mode : 'hash',
  routes: [
    {
      path: '*',
      redirect: '/login'
    },
    {
      path: '/login',
      name: '登录',
      component: Login
    },
    {
      path: '/contract-download',
      name: '电子合同下载',
      component: Download,
      meta : {
        requireAuth : true
      }
    },
    {
      path: '/contract-pdf-view',
      name: '电子合同预览',
      component: View,
      meta : {
        requireAuth : true
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js